 export class RegistrAccount {
     constructor(companyName, contactName,email, phone) {
         this.companyName = companyName;
         this.contactName = contactName;
         this.phone = phone;
         this.email = email;
    }

}
